import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'

export function deleteVehicleDefectCode(
  defectCode: string
): Promise<AxiosResponse<unknown>> {
  return instance.delete(`/vehicle-defect-code/${defectCode}`)
}
